import { render, staticRenderFns } from "./Return-button.vue?vue&type=template&id=1ca7ea9c&"
import script from "./Return-button.vue?vue&type=script&lang=js&"
export * from "./Return-button.vue?vue&type=script&lang=js&"
import style0 from "./Return-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports